import { Component, inject, OnDestroy, computed, effect, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmPopupComponent } from '@onrsr/ui/widgets';
import { AuthService } from './core/auth/services/auth.service';
import { LoaderComponent as Loader } from '@onrsr/ui/widgets';
import { LayoutComponent } from '@onrsr/ui/layout';
import { ProductService } from './core/services/product.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Loader,
    LayoutComponent,
    ConfirmPopupComponent,
  ],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss',
})
export class App implements OnDestroy {
  private authService = inject(AuthService);
  private productService = inject(ProductService);

  // Computed loading state based on auth initialization
  isLoading = computed(() => !this.authService.isInitialized());

  // Computed authentication state
  isAuthenticated = computed(() => this.authService.isUserAuthenticated());

  // Computed logout state
  isLoggingOut = computed(() => this.authService.isUserLoggingOut());

  private productsPrefetched = false;

  constructor() {
    // Prefetch products after authentication to avoid delay in opening routes
    effect(() => {
      if (this.isAuthenticated() && !this.productsPrefetched) {
        this.productsPrefetched = true;
        this.productService.initializeProducts().subscribe();
      }
    });
  }

  ngOnDestroy(): void {
    this.authService.destroy();
  }
}
